// extracted by mini-css-extract-plugin
export var formInfo = "FormInfo-module--formInfo--5f98a";
export var formInfo__image = "FormInfo-module--formInfo__image--166da";
export var formInfo__link = "FormInfo-module--formInfo__link--8e96b";
export var formInfo__list = "FormInfo-module--formInfo__list--ab74d";
export var formInfo__sectionHr = "FormInfo-module--formInfo__sectionHr--12ee2";
export var formInfo__services = "FormInfo-module--formInfo__services--16420";
export var formInfo__title = "FormInfo-module--formInfo__title--b6d6b";